import React from 'react'

import DownloadIcon from '@mui/icons-material/Download'
import { Button, CircularProgress } from '@mui/material'

interface DownloadExcelButtonProps {
  onClick?: () => void
  isLoading?: boolean
  disabled?: boolean
}

function DownloadExcelButton({ onClick, isLoading, disabled }: DownloadExcelButtonProps) {
  return (
    <Button
      variant="contained"
      startIcon={isLoading ? <CircularProgress size={24} color="primary" /> : <DownloadIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      Excel
    </Button>
  )
}

export default DownloadExcelButton
